<template lang="">
  <div class="FloorPlanPage flex-contents">
    <div class="unit-info-left">
      <img style="max-width: 100%;" :src="nowUnit.plan" alt="">
    </div>
    <div class="unit-info-right flex-contents">
      <h2>{{nowUnit.type}}</h2>
      <h4>{{nowUnit.name}}</h4>
      <!-- <p>Area:{{nowUnit.size}}</p>
      <p>Unit(s):{{nowUnit.unit}}</p> -->
       <button class="unit-btn"
       @click="UnitCompare(unitname)">Unit Compare</button>
       <button class="unit-btn"
       @click="$router.go(-1)"> << back</button>
    </div>
  </div>
</template>

<script>
export default {
data() {
  return {
    nowUnit:{
      name:'TYPE A1S',
      type:'1-BEDROOM + STUDY',
      size:'50 sqm (include of 3 sqm A/C Ledge, 4 sqm Balcony)',
      unit:'#03-13* to #19-13*, #03-28 to #19-28',
      img:"",
      plan:""
    },
    unitname:this.$route.query.unit,
    floorplan:this.$Datas.floorplan,
  }
},
mounted(){
  if(this.floorplan[this.$route.query.unit]){
    this.nowUnit = this.floorplan[this.$route.query.unit];
  }
},
methods:{
  UnitCompare(item) {
    // this.nowUnit = this.FloorplanData[item]
    this.$router
      .push({
        path: '/UnitCompare',
        query: {
          unitname: item,
        },
      })
      .catch((err) => {});
  },
}
}
</script>

<style lang="less">

.FloorPlanPage{
  position: relative;
  width: 100vw;
  height: 100vh;
  flex-direction: row;
  background-color: white;
  z-index: 203;
  .unit-btn{
    width: 200px;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    background-color: black;
    color: white;
    border: 0;
    border-radius: 5px;
    margin: 5px;
  }
  .unit-info-left{
    width: 80%;
    height: 100%;
    overflow: auto;
  }
  .unit-info-right{
    width: 19%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    justify-content: flex-start;
    text-align: start;
    align-items: flex-start;
    background-color: #62828c;
    color: white;
    padding-left:1%;
    overflow: auto;
    h2,h4,p{
      margin: 10px 0;
    }
  }
}

@media screen and (max-height: 500px){
.unit-info-left{
  width: 70% !important;
}
.unit-info-right{
  width: 30% !important;
}
.FloorPlanPage .unit-btn{
  padding: 6px !important;
  font-size: 12px !important;
}
}

</style>